
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote/smm",
      function () {
        return require("private-next-pages/quote/smm/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote/smm"])
      });
    }
  